import { isEmpty } from 'lodash';

import { ApiTypes } from '@mode/shared/contract-common';
import { Resource } from './resource';

export type LiveResource<Document> = Resource & Document;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ModeResourceHelper {
  export function isResource(resource: ApiTypes.ModeResource) {
    return !isEmpty(resource) && resource instanceof Resource;
  }

  export function resourceToModel(
    resource: ApiTypes.ModeResource,
    factory: new (resource: ApiTypes.ModeResource, options: { ignoreEmbedded: boolean }) => any
  ) {
    return (
      isResource(resource) &&
      new factory(resource, {
        ignoreEmbedded: true,
      })
    );
  }

  export function resourcesToModels(
    resources: readonly ApiTypes.ModeResource[],
    factory: new (resource: ApiTypes.ModeResource, options: { ignoreEmbedded: boolean }) => any
  ) {
    return resources && resources.map((resource) => resourceToModel(resource, factory));
  }

  export function makeResource<T>(props: T): LiveResource<T> {
    return new Resource(props) as LiveResource<T>;
  }
}
